<template>
  <div class="loading">
    <div class="loading__mask column--central">
      <img
        src="@/assets/images/logo-lcy.png"
        alt=""
        class="image--circle image--size-x-3 bc--secondary"
      >
      <div class="fc--white mt4">
        {{ content }}
      </div>
      <div class="loading__loader">
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: '',
    },
  },
};
</script>
